// @flow

import parseTemplate from '../../../helpers/parseTemplate';
// import { type Macro } from '../../../helpers/macros';
type PossibleReturn = string | Function;

type TemplateArgument = {|
  value?: PossibleReturn,
  pattern: string,
  description: string,
  hideInsertButton?: boolean,
  macro: string,
|};

const parseMacros = (callback: Function) => (content: string, macros: Array<TemplateArgument>) => parseTemplate(content, macros).map(callback).join('');

export default parseMacros;
